import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ProgressBar from "../components/ProgressBar";
import UserRegistrationForm from "../components/UserRegistrationForm";
import { sendTestResultsEmail } from "../services/emailService";
import { calculateSubtype } from "../services/testCalculations";

const questions = [
  {
    question: "Для меня важно:",
    options: [
      "жить в покое и безопасности",
      "испытывать радость от близости с партнером", 
      "принадлежать к достойному сообществу"
    ]
  },
  {
    question: "Для меня важно:",
    options: [
      "сохранять целостность",
      "получать впечатления",
      "оказывать влияние"
    ]
  },
  {
    question: "Для меня ценны:",
    options: [
      "стабильность и устойчивость",
      "глубокие переживания",
      "обширные контакты"
    ]
  },
  {
    question: "Меня более всего заботят:",
    options: [
      "практические аспекты жизни",
      "способы повеселиться",
      "реакции людей на то, что я делаю"
    ]
  },
  {
    question: "На вечеринке я стараюсь общаться:",
    options: [
      "с людьми, которых я хорошо знаю",
      "с теми, кто производит впечатление",
      "с кем возможно наладить полезные контакты"
    ]
  },
  {
    question: "Меня больше всего раздражают люди, которые:",
    options: [
      "Ненадежные",
      "Непривлекательные",
      "Неперспективные"
    ]
  },
  {
    question: "Я больше всего забочусь:",
    options: [
      "О своем здоровье",
      "О своей внешности",
      "О своей репутации"
    ]
  },
  {
    question: "Мне лучше всего помогает снять стресс:",
    options: [
      "Покой",
      "Близость с любимым человеком",
      "Общение с друзьями"
    ]
  },
  {
    question: "Я очень дорожу отношениями со своей:",
    options: [
      "Семьей",
      "Родственной душой",
      "Социальной группой"
    ]
  },
  {
    question: "Лучший спутник жизни для меня тот,",
    options: [
      "Кто может обеспечить мне финансовую устойчивость",
      "С кем у меня гармоничные и глубокие отношения",
      "С кем у меня проекты и общие цели"
    ]
  },
  {
    question: "Считают, что у меня есть такое качество, как",
    options: [
      "Бережливость",
      "Ветреность",
      "Амбициозность"
    ]
  },
  {
    question: "Я предпочитаю отдыхать:",
    options: [
      "Ухаживая за своим садом",
      "В танцевальном зале",
      "На встрече с друзьями"
    ]
  },
  {
    question: "Когда со мной начинают назойливо общаться не интересные для меня люди, я:",
    options: [
      "Тихо ухожу",
      "Веду себя с ними холодно и отстраненно",
      "Стараюсь установить с ними контакт"
    ]
  },
  {
    question: "Я чаще использую для достижения цели:",
    options: [
      "Терпение",
      "Обаяние",
      "Напористость"
    ]
  },
  {
    question: "В моей деятельности больше продуктивности, когда работаю:",
    options: [
      "Самостоятельно",
      "С вдохновляющим партнером",
      "С дружной командой"
    ]
  },
  {
    question: "Мне было бы особенно трудно пожертвовать",
    options: [
      "Своей автономией",
      "Своими отношениями с партнером",
      "Своими отношениями с друзьями"
    ]
  },
  {
    question: "Я чаще всего выбираю одежду:",
    options: [
      "Практичную и удобную",
      "Привлекающую внимание",
      "Подходящую для ситуации"
    ]
  },
  {
    question: "Я предпочитаю читать:",
    options: [
      "Книги, содержащие практические рекомендации",
      "Любовные романы",
      "Книги, популярные в моем сообществе"
    ]
  },
  {
    question: "Мои друзья особенно ценят во мне:",
    options: [
      "Надежность",
      "Эмоциональность",
      "Общительность"
    ]
  },
  {
    question: "Когда я захожу в помещение, полное людей, я обычно обращаю внимание на:",
    options: [
      "Комфортность и убранство помещения",
      "Тех, с кем можно пофлиртовать",
      "Возможность пообщаться с нужными людьми"
    ]
  },
  {
    question: "Иногда в моем поведении слишком много:",
    options: [
      "Неприхотливости",
      "Импульсивности",
      "Зависимости от мнений своей группы"
    ]
  },
  {
    question: "Для меня важна:",
    options: [
      "Безопасность, которую выстраиваю",
      "Любовь, которую чувствую",
      "Признание, которое зарабатываю"
    ]
  },
  {
    question: "Я предпочитаю проводить выходные:",
    options: [
      "В одиночестве",
      "С избранником сердца",
      "С друзьями"
    ]
  },
  {
    question: "Я больше фокусирую внимание:",
    options: [
      "На своих потребностях",
      "На потребностях своего партнера",
      "На потребностях своего сообщества"
    ]
  },
  {
    question: "Мне дискомфортно:",
    options: [
      "От больших собраний",
      "От рутинной работы",
      "От длительного уединения"
    ]
  },
  {
    question: "Друзья считают, что во мне преобладает:",
    options: [
      "Основательность и практичность",
      "Легкомысленность и страсть",
      "Сила и предприимчивость"
    ]
  },
  {
    question: "В моих представлениях идеальный дом:",
    options: [
      "Безопасная крепость",
      "Уютное гнездышко для наслаждений",
      "Место для встречи с единомышленниками"
    ]
  },
  {
    question: "В моих представлениях идеальный автомобиль:",
    options: [
      "Надежный как танк",
      "Модный и скоростной",
      "Респектабельный"
    ]
  },
  {
    question: "У меня есть склонность:",
    options: [
      "Откладывать сэкономленные деньги на «черный» день",
      "Тратить все спонтанно",
      "Тратить деньги продумано для достижения поставленных целей"
    ]
  },
  {
    question: "Мне нравится:",
    options: [
      "Заботиться об уюте в доме",
      "Ощущать пиковые переживания",
      "Выстраивать коммуникации с людьми"
    ]
  }
];

const SubtypeTest = () => {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState({});
  const [userInfo, setUserInfo] = useState({
    full_name: "",
    email: "",
    phone: ""
  });
  const [isStarted, setIsStarted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleStart = () => {
    setIsStarted(true);
  };

  const handleAnswerChange = (value) => {
    setAnswers({
      ...answers,
      [currentQuestion + 1]: value
    });
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' || e.key === 'Return') {
      if (currentAnswer !== undefined) {
        if (isLastQuestion) {
          submitTest();
        } else {
          nextQuestion();
        }
      }
    }
  };

  const nextQuestion = () => {
    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    }
  };

  const prevQuestion = () => {
    if (currentQuestion > 0) {
      setCurrentQuestion(currentQuestion - 1);
    }
  };

  const submitTest = async () => {
    setIsSubmitting(true);
    try {
      // Calculate results on frontend
      const testResult = calculateSubtype(answers);
      testResult.userInfo = userInfo;
      testResult.testType = 'subtype';
      testResult.answers = answers; // Добавляем исходные ответы для детального отображения
      testResult.summary = `Ваш доминирующий подтип: ${testResult.dominantSubtype}`;
      
      // Send email with detailed results
      const emailResult = await sendTestResultsEmail(testResult, 'subtype');
      
      if (emailResult.success) {
        console.log('✅ Email sent successfully');
        if (emailResult.excelCreated) {
          console.log(`📊 Excel file created: ${emailResult.excelFileName}`);
        }
      } else {
        console.error('❌ Email sending failed:', emailResult.error);
      }
      
      // Excel файл для теста Subtype не поддерживается
      console.log('📊 Excel файл для теста Subtype не создается (не поддерживается)');
      
      // Store results for display
      const displayResult = {
        id: Date.now().toString(),
        test_type: 'subtype',
        user_info: userInfo,
        results: {
          allSubtypes: testResult.allSubtypes,
          dominantSubtype: testResult.dominantSubtype,
          topSubtypes: testResult.topSubtypes
        },
        timestamp: new Date().toISOString()
      };
      
      // Store in localStorage for display
      localStorage.setItem('lastTestResult', JSON.stringify(displayResult));
      
      // Navigate to thank you page
      navigate('/thank-you');
      
    } catch (error) {
      console.error("Error submitting test:", error);
      alert("Ошибка при отправке результатов. Попробуйте еще раз.");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isStarted) {
    const testDescription = (
      <div className="mb-6 p-4 bg-orange-50 rounded-md">
        <h3 className="font-semibold text-orange-800 mb-2">О тесте:</h3>
        <p className="text-orange-700 text-sm mb-2">
          Тест на подтип личности поможет определить ваш основной инстинктивный подтип 
          и понять, как вы взаимодействуете с миром на базовом уровне.
        </p>
        <p className="text-orange-700 text-sm">
          Оцените каждое утверждение по шкале от 1 до 5, где 1 - совсем не подходит, 5 - очень подходит.
        </p>
      </div>
    );

    // const additionalInfo = (
    //   <div className="mb-6 p-4 bg-orange-100 rounded-md">
    //     <h3 className="font-semibold text-orange-800 mb-2">Инстинктивные подтипы:</h3>
    //     <ul className="text-orange-700 text-sm space-y-1">
    //       <li><strong>SP (Самосохранение)</strong> - фокус на безопасности, здоровье, комфорте</li>
    //       <li><strong>SX (Сексуальный)</strong> - фокус на интенсивности, привлекательности, личных связях</li>
    //       <li><strong>SO (Социальный)</strong> - фокус на группе, статусе, социальных связях</li>
    //     </ul>
    //   </div>
    // );
    return (
      <UserRegistrationForm
        userInfo={userInfo}
        setUserInfo={setUserInfo}
        onStart={handleStart}
        testTitle="Тест на подтип личности"
        testDescription={testDescription}
        // additionalInfo={additionalInfo}
        buttonText="Начать тест (30 вопросов)"
      />
    );
  }

  const isLastQuestion = currentQuestion === questions.length - 1;
  const currentAnswer = answers[currentQuestion + 1];
  const currentQuestionData = questions[currentQuestion];

  return (
    <div className="container mx-auto px-4 py-8" onKeyPress={handleKeyPress} tabIndex={0}>
      <div className="max-w-3xl mx-auto">
        <div className="bg-white p-8 rounded-lg shadow-md">
          <ProgressBar current={currentQuestion + 1} total={questions.length} className="mb-8" />
          
          <div className="mb-8">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              Вопрос {currentQuestion + 1}
            </h2>
            <p className="text-gray-700 text-lg mb-6">
              {currentQuestionData.question}
            </p>
            
            <div className="mb-4 p-3 bg-orange-50 rounded-md">
              <p className="text-orange-800 text-sm">
                💡 <strong>Подсказка:</strong> Выберите наиболее подходящий вариант и нажмите Enter для перехода к следующему вопросу.
              </p>
            </div>
            
            <div className="space-y-3">
              {currentQuestionData.options.map((option, index) => (
                <label key={index} className="flex items-start cursor-pointer p-3 border border-gray-200 rounded-md hover:bg-orange-50 hover:border-orange-300 transition-colors">
                  <input
                    type="radio"
                    name={`question-${currentQuestion}`}
                    value={index}
                    checked={currentAnswer === index}
                    onChange={() => handleAnswerChange(index)}
                    onKeyPress={handleKeyPress}
                    className="mr-3 mt-1 text-orange-600 focus:ring-orange-500"
                  />
                  <span className="text-gray-700">
                    {String.fromCharCode(97 + index)}) {option}
                  </span>
                </label>
              ))}
            </div>
          </div>

          <div className="flex justify-between">
            <button
              onClick={prevQuestion}
              disabled={currentQuestion === 0}
              className="px-6 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Назад
            </button>
            
            {isLastQuestion ? (
              <button
                onClick={submitTest}
                disabled={isSubmitting || currentAnswer === undefined}
                className="px-6 py-2 bg-orange-600 text-white rounded-md hover:bg-orange-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSubmitting ? "Отправка..." : "Завершить тест"}
              </button>
            ) : (
              <button
                onClick={nextQuestion}
                disabled={currentAnswer === undefined}
                className="px-6 py-2 bg-orange-600 text-white rounded-md hover:bg-orange-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Далее
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubtypeTest;
